import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { del, put } from "../../utils/api";

const DeleteDialog = ({
  deleteDialog,
  setDeleteDialog,
  url,
  id,
  method = "put",
  setsnackOpen,
  fetchData,
  fetchCardData,
}) => {
  const handleDeleteAggree = async () => {
    try {
      const res =
        method === "put"
          ? await put(`${url}?Id=${id}`)
          : await del(`${url}?Id=${id}`);
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      await fetchData();
      if (typeof fetchCardData === "function") {
        await fetchCardData();
      }
    } catch (err) {
      setsnackOpen({
        open: true,
        message:
          err.response?.data?.message ||
          err?.data?.response?.message ||
          "network Error",
        severity: "error",
      });
    }
  };

  return (
    <Dialog open={deleteDialog} onClose={() => setDeleteDialog(false)}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you really want to delete this entry?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDeleteDialog(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={handleDeleteAggree} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
